/** @jsx jsx */

import { Dropdown, Typography } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

type SelectableItem = {
  label: string;
  value: string;
};

type PartnerEmbedDropdownProps<T extends SelectableItem> = {
  items: T[];
  initialSelectedItem: T;
  onSelect: (value: T['value']) => void;
};

const styleRoot = css`
  min-width: 320px;

  & div[class$='Input-Input--root'] {
    ${Typography.Body2};
  }

  & div[class$='FloatingBox--Styles'] {
    ${Typography.Body2};
    width: max-content !important;
  }
  & ul[class$='FloatingMenu__list'] {
    max-height: 300px !important;
  }
`;

export default function PartnerEmbedDropdown<T extends SelectableItem>({
  initialSelectedItem,
  items,
  onSelect,
}: PartnerEmbedDropdownProps<T>) {
  return (
    <div css={styleRoot} data-testid="PartnerEmbedTypeDropDown">
      <Dropdown
        aria-label="Embed type"
        initialSelectedItem={initialSelectedItem}
        items={items}
        menuAriaLabel="Embed type selection"
        onSelect={item => {
          onSelect(item.value);
        }}
        placeholder="Choose an embed type..."
      />
    </div>
  );
}
